exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* .faq-question-box.collapsed {\n    background-color: #000;\n} */\n\n/* .faq-question-box {\n    background-color: #f10909;\n} */", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/projects/wct-nextias-ui/src/app/home/vfaq/vfaq.component.css
// module id = ../../../../../src/app/home/vfaq/vfaq.component.css
// module chunks = common